import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../_metronic/partials/control";
// import * as actions from "../../../_redux/purchases/purchasesActions";
import { usePurchasesUIContext, PurchasesUIContextModel } from '../PurchasesUIContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { PurchasesLoadingDialog } from '../purchases-loading-dialog/PurchasesLoadingDialog';

export interface PurchaseDeleteDialogProps {
  id?: number | null;
  fullDelete?: number | null;
  show: boolean
  onHide: () => void
}
export const PurchaseDeleteDialog: React.FC<PurchaseDeleteDialogProps> = ({ id, fullDelete, show, onHide }) => {
  // Purchases UI Context
  const purchasesUIContext = (usePurchasesUIContext() as PurchasesUIContextModel);
  const purchasesUIProps = useMemo(() => {
    return {
      setIds: purchasesUIContext.setIds,
      queryParams: purchasesUIContext.queryParams,
      selectedPurchase: purchasesUIContext.selectedPurchase,
      fetchPurchase: purchasesUIContext.fetchPurchase,
      loadPurchase: purchasesUIContext.loadPurchase,
      loadPurchases: purchasesUIContext.loadPurchases,
      setIsLoading: purchasesUIContext.setIsLoading
    };
  }, [purchasesUIContext]);
  const status = purchasesUIProps.selectedPurchase?.status;
  // const { isLoading } = useSelector(
  //   (state) => ({ isLoading: state.purchases.actionsLoading }),
  //   shallowEqual
  // );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    } else {
      purchasesUIProps.fetchPurchase((id as number));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  // useEffect(() => {}, [ dispatch]);

  const deletePurchase = async() => {
    purchasesUIProps.setIsLoading(true);
    try {
      if(fullDelete === 1) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/purchase/${id}`,
          {
            ...purchasesUIProps.selectedPurchase,
            status: purchasesUIProps.selectedPurchase?.status === 1 ? 0 : 1,
          }
        )
        purchasesUIProps.setIsLoading(false);
        Swal.fire({
          title: `Orden de compra ${status ? "desactivada": "activada"} correctamente`,
          icon: 'success'
        }).then(()=>{
          purchasesUIProps.loadPurchases()
        })
      } else {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/purchase/${id}`
        )
        purchasesUIProps.setIsLoading(false);
        await Swal.fire({
          title: 'Orden de compra eliminada correctamente',
          icon: 'success'
        })
      }
    } catch (error) {
      console.log('error', error)
      purchasesUIProps.setIsLoading(false);
      await Swal.fire({
        title: 'Error al eliminar orden de compra',
        icon: 'error'
      })
    } finally {
      await purchasesUIProps.loadPurchases()
			onHide()
		}
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/*begin::Loading*/}
      {false && <ModalProgressBar />}
      {/*end::Loading*/}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          { purchasesUIProps.loadPurchase ? 'Cargando...' : `
           ${ fullDelete === 1 ? purchasesUIContext.selectedPurchase?.status ? "Desactivar" : "Activar" : "Eliminar"} 
          compra ${purchasesUIProps.selectedPurchase?.reference}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {purchasesUIProps.loadPurchase && <PurchasesLoadingDialog color={"primary"}/>}
        {!purchasesUIProps.loadPurchase && (
          <span>
            { fullDelete === 1 ? status ? "¿Está seguro que desea desactivar esta compra?" : "¿Está seguro que desea activar esta compra?" : "¿Está seguro que desea eliminar esta compra?"}
          </span>
        )}
      </Modal.Body>
      <Modal.Footer>
        {
          !purchasesUIProps.loadPurchase && 
            <div>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="button"
                onClick={deletePurchase}
                className={`btn btn-${fullDelete === 1 ? status ? 'danger':'success':'danger'} btn-elevate`}
              >
                {fullDelete === 1 ? status ? "Desactivar" : "Activar" : "Eliminar"}
              </button>
            </div>
        }
      </Modal.Footer>
    </Modal>
  );
}


